// extracted by mini-css-extract-plugin
export var skipAnimation = "_redotech-react-animation-lib-transition-skip-animation";